import { AfterViewInit, Component, ElementRef, OnInit } from '@angular/core';

import { NgxUiLoaderService } from 'ngx-ui-loader';
import { IVehicleDetails } from '../compare-vehicle.interface';
import { formatNumber } from '@angular/common';

@Component({
  selector: 'lib-compare-blocks-ui',
  templateUrl: './compare-blocks-ui.component.html',
  styleUrls: ['./compare-blocks-ui.component.scss']
})
export class CompareBlocksUiComponent implements OnInit, AfterViewInit {
  carsArray!: Array<IVehicleDetails>;
  hasError: boolean = false;
  loaderId = 'load-compare-vehicle';  //ngx-ui-loader id
  showLoader = false;
  viewMode: string;
  showMpg = false;
  showEngine = false;
  showDriveType = false;
  showTransmission = false;
  showRange = false;
  showVin = false;
  showSeatCount = false;
  scrollPoint: any;
  middleSection: any;
  stickyHeader: any;
  compHeader: any;
  infoSection: any;
  modal: any;
  top: number = 0;
  isSRP: any;

  fuletypes = [
    {
      "Title": "Gas",
      "Key": "GF",
      "Value": "Gasoline Fuel|Gasoline/Natural Gas|Hydrogen Fuel|Flex Fuel Capability|Gasoline/Mild Electric Hybrid",
      "ShowCompareonSRP": false,
      "ShowBadgeOnSRP": false,
      "FuelTypeBadgeSRP": ""
    },
    {
      "Title": "Diesel",
      "Key": "DF",
      "Value": "Diesel Fuel",
      "ShowCompareonSRP": false,
      "ShowBadgeOnSRP": false,
      "FuelTypeBadgeSRP": ""
    },
    {
      "Title": "Electric",
      "Key": "EF",
      "Value": "Electric Fuel System",
      "ShowCompareonSRP": true,
      "ShowBadgeOnSRP": true,
      "FuelTypeBadgeSRP": "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"20\" height=\"20\" viewBox=\"0 0 20 20\"><defs><style>.electric-a{fill:none;}.electric-b{stroke:rgba(0,0,0,0);stroke-miterlimit:10;}</style></defs><g transform=\"translate(-730 -293)\"><g transform=\"translate(730 293)\"><rect class=\"electric-a\" width=\"20\" height=\"20\" rx=\"3\"/></g><g transform=\"translate(731 293)\"><path d=\"M1023.442,321.045a9.563,9.563,0,0,1-8.647-5.467h-.5a10.018,10.018,0,0,0,18.283,0h-.5a9.563,9.563,0,0,1-8.646,5.467m0-19.091a9.563,9.563,0,0,1,8.646,5.468h.5a10.018,10.018,0,0,0-18.283,0h.5a9.563,9.563,0,0,1,8.647-5.468\" transform=\"translate(-1014.3 -301.501)\"/><path class=\"electric-b\" d=\"M2.946,10.689a.226.226,0,0,1-.225-.242l.39-3.76H.223a.223.223,0,0,1-.19-.341L3.6.1A.225.225,0,0,1,4.01.249L3.518,4H6.449a.224.224,0,0,1,.192.338l-3.5,6.244A.224.224,0,0,1,2.946,10.689Z\" transform=\"translate(5.714 4.571)\"/></g></g></svg>\n<span class=\"srp-ft-electric\">ELECTRIC</span>"
    },
    {
      "Title": "Hybrid",
      "Key": "HY",
      "Value": "Flex Fuel/Electric Hybrid|Gas/Electric Hybrid",
      "ShowCompareonSRP": true,
      "ShowBadgeOnSRP": true,
      "FuelTypeBadgeSRP": "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"20\" height=\"20\" viewBox=\"0 0 20 20\"><defs><style>.hybrid-a{fill:none;}.hybrid-b{fill:#fff;}</style></defs><g transform=\"translate(-730 -234)\"><g transform=\"translate(730 234)\"><rect class=\"hybrid-a\" width=\"20\" height=\"20\" rx=\"3\"/></g><g transform=\"translate(675 -49.954)\"><g transform=\"translate(61.131 289.131)\"><g transform=\"translate(0)\"><path d=\"M51.156,1.345,50.3.49a.214.214,0,0,0-.3.3l.7.7-.7.7a.214.214,0,0,0-.063.151v.641a.856.856,0,0,0,.855.855V7.483a.214.214,0,1,1-.428,0V7.055a.642.642,0,0,0-.641-.641h-.214V.855A.856.856,0,0,0,48.653,0H44.377a.856.856,0,0,0-.855.855v7.7a.856.856,0,0,0-.855.855v.641a.214.214,0,0,0,.214.214H50.15a.214.214,0,0,0,.214-.214V9.407a.856.856,0,0,0-.855-.855V6.841h.214a.214.214,0,0,1,.214.214v.428a.641.641,0,0,0,1.283,0V1.5A.214.214,0,0,0,51.156,1.345Zm-6.779-.276a.214.214,0,0,1,.214-.214h3.848a.214.214,0,0,1,.214.214v2.57a.214.214,0,0,1-.214.214H44.591a.214.214,0,0,1-.214-.214Z\" transform=\"translate(-42.667)\"/><g transform=\"translate(2.434 4.443)\"><path class=\"hybrid-b\" d=\"M169.907,236.762a.1.1,0,0,0-.085-.05H168.54l.215-1.643a.1.1,0,0,0-.18-.064l-1.559,2.732a.1.1,0,0,0,.083.149h1.263l-.17,1.645a.1.1,0,0,0,.181.06l1.534-2.732a.1.1,0,0,0,0-.1Zm0,0\" transform=\"translate(-167 -234.961)\"/></g></g></g><path d=\"M1023.422,321a9.543,9.543,0,0,1-8.628-5.456h-.494a10,10,0,0,0,18.244,0h-.494a9.542,9.542,0,0,1-8.628,5.456m0-19.05a9.542,9.542,0,0,1,8.628,5.456h.494a10,10,0,0,0-18.244,0h.494a9.543,9.543,0,0,1,8.628-5.456\" transform=\"translate(-958.3 -17.501)\"/></g></g></svg>\n<span class=\"srp-ft-hybrid\">HYBRID</span>"
    },
    {
      "Title": "Plug-In Hybrid",
      "Key": "PG",
      "Value": "Plug-In Electric/Gas",
      "ShowCompareonSRP": true,
      "ShowBadgeOnSRP": true,
      "FuelTypeBadgeSRP": "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"20.925\" height=\"20.75\" viewBox=\"0 0 20.925 20.75\"><defs><style>.plugin-a{fill:none;}.plugin-b{stroke:#fff;stroke-width:0.75px;}</style></defs><g transform=\"translate(-820.624 -233.625)\"><g transform=\"translate(821 234)\"><rect class=\"plugin-a\" width=\"20\" height=\"20\" rx=\"3\"/></g><g transform=\"translate(455 -327)\"><path class=\"plugin-b\" d=\"M10.071,20a11.113,11.113,0,0,1-5.582-1.489A10.062,10.062,0,0,1,.577,14.443,5.253,5.253,0,0,1,.014,12.5a3,3,0,0,1,.672-2.348,3.2,3.2,0,0,1,2.405-.878c.607-.007,1.191-.008,1.733-.008h.9l1.16,0h.4c.022-.075.042-.148.059-.212.037-.135.074-.274.123-.406a3.451,3.451,0,0,1,3.323-2.229c.074,0,.146,0,.213.006.365.019.521.02.871.02h.091v7.124a8.123,8.123,0,0,1-1.03.07,3.854,3.854,0,0,1-2.2-.572,3.581,3.581,0,0,1-1.4-2.167c-.007-.025-.017-.052-.03-.086L7.3,10.8l-.018-.048H6.564c-.176,0-.323,0-.465,0-.317,0-.645.006-.954.007H5.139c-.783,0-1.593.007-2.387.055a1.3,1.3,0,0,0-.93.383,1.185,1.185,0,0,0-.249.913,4.471,4.471,0,0,0,.405,1.647,9.029,9.029,0,0,0,8.109,4.757,9.672,9.672,0,0,0,1.3-.089A9.042,9.042,0,0,0,18.017,14h1.748a10.269,10.269,0,0,1-3.332,3.983,10.837,10.837,0,0,1-5.12,1.948A11.438,11.438,0,0,1,10.071,20ZM.846,7.583a.854.854,0,0,1-.282-.049A.764.764,0,0,1,.1,7.123a.72.72,0,0,1,.025-.594L.2,6.377A13.034,13.034,0,0,1,1.127,4.63,10.364,10.364,0,0,1,4.993,1.215,11.135,11.135,0,0,1,10.059,0a11.352,11.352,0,0,1,2.267.229A10.741,10.741,0,0,1,17.035,2.48,10.136,10.136,0,0,1,20,6.571H18.309a8.874,8.874,0,0,0-5.927-4.8,9.434,9.434,0,0,0-2.34-.3A9.084,9.084,0,0,0,1.695,6.8l-.037.09L1.652,6.9c-.022.054-.046.111-.07.165A.807.807,0,0,1,.846,7.583Z\" transform=\"translate(366 561)\"/><path d=\"M3.474,0q1.48,0,2.96,0c.406,0,.511.13.515.611q0,.257,0,.514c0,.483-.109.612-.513.614-.717,0-1.433,0-2.15,0q-1.87,0-3.739,0C.1,1.74,0,1.626,0,1.092,0,0,0,0,.919,0Z\" transform=\"translate(379.623 567.635) rotate(90)\"/><path d=\"M1.085,2.715H0C0,1.981-.009,1.265.01.551A.537.537,0,0,1,.536,0,.543.543,0,0,1,1.08.568C1.1,1.273,1.085,1.979,1.085,2.715Z\" transform=\"translate(381.713 568.998) rotate(90)\"/><path d=\"M1.085,2.716H0C0,1.981-.009,1.265.01.55A.54.54,0,0,1,.537,0,.548.548,0,0,1,1.08.571C1.1,1.276,1.085,1.981,1.085,2.716Z\" transform=\"translate(381.714 572.135) rotate(90)\"/></g></g></svg><span class=\"srp-ft-plugin\">PLUG-IN</span>\n"
    }
  ];

  constructor(
    public ngxService: NgxUiLoaderService,
    private elementRef: ElementRef
  ) {
    this.viewMode = '';
    this.isSRP = window.location.href.indexOf("cars-for-asas") > -1;

    document.addEventListener('__LOAD__VEHICLE__COMPARE__SECTION__', (eventData: any) => {
      console.log('__LOAD__VEHICLE__COMPARE__SECTION__ received in compare block component');
      let loadedData = eventData.detail?.carsArray;
      this.viewMode = eventData.detail?.viewMode;
      console.log('viewMode - ', this.viewMode);
      console.log('loadedData - ', loadedData);
      this.modifyData(loadedData);
    });
  }

  ngOnInit(): void {
  }

  ngAfterViewInit() {
    if (this.isSRP) {
      let elem = this.elementRef.nativeElement.getElementsByClassName('outer-div-wrapper')[0];
      this.scrollPoint = document.getElementsByClassName('header-title')[0];
      this.middleSection = document.getElementsByClassName('modal-content-middle-section')[0];
      this.stickyHeader = document.getElementsByClassName('info-section-sticky-header');
      this.compHeader = document.getElementsByClassName('modal-content-upper-section')[0];
      this.infoSection = document.getElementsByClassName('info-section');
      this.modal = document.getElementsByClassName('modal-compare')[0];
      this.top = 0;
      elem.addEventListener('scroll', ((event: any) => {
        if (window.pageYOffset > document.getElementsByClassName('header-title')[0].getBoundingClientRect().bottom - 60) {
          for (var i = 0; i < this.stickyHeader.length; i++) {
            this.stickyHeader[i].style.zIndex = 1000;
            if (window.outerWidth < 768) {
              this.stickyHeader[i].style.display = 'block';
              this.compHeader.style.position = 'fixed';
              this.compHeader.style.width = '100%';
              this.compHeader.style.zIndex = '10';
              this.compHeader.style.background = 'inherit';
              this.middleSection.style.marginTop = '65px';
            }
          }

          let upperSection = document.getElementsByClassName('modal-content-upper-section')[0] as HTMLElement;
          for (var j = 0; j < this.stickyHeader.length; j++) {
            var infoSectionTop = Math.abs(this.infoSection[0].getBoundingClientRect().top);
            var middleSectionTop = this.modal.scrollTop;
            if (middleSectionTop > 0) {
              this.top = Math.abs(infoSectionTop + upperSection.offsetHeight);
            }
            else {
              this.top = Math.abs(middleSectionTop - infoSectionTop) + upperSection.offsetHeight;
            }
            this.stickyHeader[j].style.top = this.top + 'px';
          }

        } else {
          for (var k = 0; k < this.stickyHeader.length; k++) {
            this.stickyHeader[k].style.zIndex = -1;
            if (window.outerWidth < 768) {
              this.stickyHeader[k].style.display = 'none';
            }
          }
        }
      }));
    }
  }

  tileLinkUrl(vehicle: any) {
    let year = vehicle.VehicleYear.toLowerCase();
    let make = vehicle.VehicleMake.toLowerCase();
    let model = vehicle.VehicleModel.toLowerCase();
    return '/cars/' + vehicle.Vin.toLowerCase() + '/' + make?.replace(' ', '-').replace('.', '').replace('&', '') + '-' + model?.replace(' ', '-').replace('.', '').replace('&', '') + '-' + year;
  }

  modifyData(loadedData: any): void {
    this.carsArray = [];
    if (loadedData && loadedData.length > 0) {
      this.setFlags(loadedData);
      let tites = {
        Engine: "Engine",
        Transmission: "Transmission",
        VehicleDriveType: "DriveType",
        MPG: "MPG/MPGe",
        SeatCount: "Seat Count",
        Range: "Range",
        Fuel: "Fuel",
        StoreName: "Store Name",
        Distance: "Distance",

        MSRP: "",
        FormattedPrice: "",
        FormattedDistance: "",
        MPGMPGeCity: "",
        StorePhoneNumber: "",
        Mileage: "",
        isCompareEnabled: true,
        IsSaved: false,
        VehicleMake: "",
        VehicleModel: "",
        VehicleTrim: "",
        VehicleYear: "",
        ThumbImage: "",
        Zipcode: "",
        MPGMPGeHW: "",
        Vin: "",
        Condition: "",
        StockBgColor: ""
      };
      this.carsArray.push(tites);
      loadedData.forEach((vehicle: IVehicleDetails) => {
        vehicle['FormattedPrice'] = '$' + formatNumber(Number((parseInt(vehicle.MSRP)).toFixed(0)), 'en-US', '1.0-0');
        vehicle['FormattedDistance'] = vehicle.Distance ? Number((parseInt(vehicle.Distance)).toFixed(0)).toString() : '';
        vehicle['MPG'] = this.getMpg(vehicle);
        vehicle['IsSaved'] = this.IsSaved(vehicle.Vin);

        if (vehicle.FormattedDistance) this.carsArray[0].FormattedDistance = 'Distance';

        this.carsArray.push(vehicle);
      });
    }
    console.log('this.carsArray - ', this.carsArray);
  }

  setFlags(loadedData: any) {
    if (loadedData.every((v: IVehicleDetails) => v.MPG && v.MPG !== '--')) {
      this.showMpg = true;
    }

    if (loadedData.every((v: IVehicleDetails) => v.Engine && v.Engine !== '-')) {
      this.showEngine = true;
    }

    if (loadedData.every((v: IVehicleDetails) => v.VehicleDriveType && v.VehicleDriveType !== '-')) {
      this.showDriveType = true;
    }

    if (loadedData.every((v: IVehicleDetails) => v.Transmission && v.Transmission !== '-')) {
      this.showTransmission = true;
    }

    if (loadedData.every((v: IVehicleDetails) => v.Range && v.Range !== '--')) {
      this.showRange = true;
    }

    if (loadedData.every((v: IVehicleDetails) => v.Vin && v.Vin !== '-')) {
      this.showVin = true;
    }

    if (loadedData.every((v: IVehicleDetails) => v.SeatCount && v.SeatCount !== '-')) {
      this.showSeatCount = true;
    }
  }

  IsSaved(vin?: any) {
    let savedVehicles = this.getCookie('SavedVehicleData');
    return savedVehicles.toString().indexOf(vin) > -1 ? true : false;
  }

  isMobileView(): boolean {
    return window.screen.width <= 767;
  }

  setBadge(fuelType: string) {
    const badge = this.getBadgeDetails(fuelType);
    if (!badge) {
      return '';
    }
    return badge;
  }

  getBadgeDetails(fuelType: string) {
    let result;
    for (const ft of this.fuletypes) {
      if (ft.Value.indexOf('|') !== -1) {
        const fuelTypesString = ft.Value;
        if (fuelTypesString !== undefined) {
          const lst = fuelTypesString.split('|');
          for (let i = 0; i < lst.length; i++) {
            if (lst[i].trim().toLowerCase() === fuelType.trim().toLowerCase()) {
              result = ft.FuelTypeBadgeSRP;
            }
          }
        }
      } else {
        if (ft.Value.trim().toLowerCase() === fuelType.trim().toLowerCase()) {
          result = ft.FuelTypeBadgeSRP;
        }
      }
    }
    return result;
  }

  getMpg(c: any): string {
    if (c.MPGMPGeCity && c.MPGMPGeCity !== '--' && c.MPGMPGeHW && c.MPGMPGeHW !== '--') {
      return `${c.MPGMPGeCity} CTY / ${c.MPGMPGeHW} HWY`;
    }
    return '--';
  }

  getCookie(name: string) {
    const cookies: Array<string> = document.cookie.split(';');
    const cookiesLength: number = cookies.length;
    let cookieName = `${name}=`;
    let cookie: string;

    for (let i: number = 0; i < cookiesLength; i += 1) {
      cookie = cookies[i].replace(/^\s+/g, '');
      if (cookie.indexOf(cookieName) === 0) {
        return cookie.substring(cookieName.length, cookie.length);
      }
    }
    return '';
  }

}
